import {
  FilterValueDTO,
  IFilterDTO,
  ISearchDisplayFieldDTO,
} from 'business/models/Models';
import { IOption } from 'components/input/selectInput';

export const enum FilterViews {
  PARAMETER_SELECTION = 'PARAMETER_SELECTION',
  SELECTED_PARAMETERS = 'SELECTED_PARAMETERS',
}

export const enum ValueType {
  NUMBER = 'Number',
  INTEGER = 'Integer',
  STRING = 'String',
  DATE = 'Date',
  DATE_IMAGED = 'DateImagedMaxMin',
}

export const enum TableViews {
  VIEW_TABLE = 'VIEW_TABLE',
  EDIT_TABLE = 'EDIT_TABLE',
}

export interface FilterDataDTO extends IFilterDTO {
  isFetching?: boolean;
  allValues?: any[];
  selectedValues?: string[];
  originalValues?: FilterValueDTO[];
}

export interface FiltersState {
  distinctRows: boolean;
  enableFilters: boolean;
  data: FilterDataDTO[];
  primaryFilter: number | undefined;
}

interface SearchFieldFilterOption extends IOption {
  filter: (sf: ISearchDisplayFieldDTO) => boolean;
}

export const searchFieldsFilters: SearchFieldFilterOption[] = [
  { title: 'All', value: 0, filter: (sf) => true },
  { title: 'Selected', value: 1, filter: (sf) => sf !== undefined },
  { title: 'Unselected', value: 2, filter: (sf) => sf === undefined },
];

export const MIN_FILTER_VALUES = 10;
